import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Types from "../../constants/Types";
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import Badge from '@material-ui/core/Badge';
import {API} from "@beardeddevops/react.api";
import PropTypes from "prop-types";
import Framework from '@beardeddevops/react.framework'
import APPCONFIG from "../../constants/Config";


export class Notification extends Component {

	static propTypes = {
		locations: PropTypes.array,
	};

	constructor(props) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.onMouseEnter = this.onMouseEnter.bind(this);
		this.onMouseLeave = this.onMouseLeave.bind(this);
		this.state = {
			dropdownOpen: false,
			acquisitions_clicked: false,
			notifications: [],
		};
		global.notified = [];
	};

	componentDidMount() {
		// this.loadNotifications().then();

		const {rootState} = this.props;

		this.state.notifications = rootState.notifications;
		this.state.pending_acquisitions = rootState.pending_acquisitions;

		this.rootStateID = rootState.subscribe({
			pending_acquisitions: null,
			notifications: null,
		});
	}


	componentWillUnmount() {
		// Components need to unsubscribe from state events when unmounting, otherwise it will prevent garbage
		// collection, cause memory leaks from lingering callback references, and React will show warnings
		// about setting state in unmounted components.
		this.props.rootState.unsubscribe(this.rootStateID);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.rootState.pending_acquisitions !== this.state.pending_acquisitions || this.props.rootState.notifications !== this.state.notifications) {

			if (this.props.rootState.pending_acquisitions > this.state.pending_acquisitions) {
				this.setState({acquisitions_clicked: false})
			}
			this.setState({notifications: this.props.rootState.notifications, pending_acquisitions: this.props.rootState.pending_acquisitions})
		}
	}

	toggle() {
		this.setState(prevState => ({
			dropdownOpen: !prevState.dropdownOpen
		}));
	};

	onMouseEnter() {
		this.setState({dropdownOpen: true});
	};

	onMouseLeave() {
		this.setState({dropdownOpen: false});
	};

	// loadNotifications = async () => {
	// 	this.notifications = [];
	// 	this.pendingA = 0;
	// 	this.setState({loading: true});
	// 	let teModel = new API.BuildClass(Types.Accounts_Notifications._name, API.RequestType.READ_ALL);
	// 	try {
	// 		/** @type {{pending_acquisitions: string}} data */
	// 		let data = await teModel.submit(null, API.RequestType.READ_ALL).then();
	// 		this.notifications = [];
	// 		this.pendingA = data.pending_acquisitions;
	// 	} catch (e) {
	// 	}
	// 	this.setState({loading: false});
	// };

	renderLinks(name) {
		let array = name.split("-")
		switch (array[0]) {
			case 'cleo':
				return '/accounts';
			case 'security':
				return '/security';
			case 'product':
				return '/products';
			case 'send':
				return '';

			default:
				return '/#';
		}
	};

	handleNotify = async (pkey, binary_id) => {
		let teModel = new API.BuildClass(Types.Accounts_Notifications._name, API.RequestType.UPDATE);

		teModel.object.pkey = pkey;
		teModel.object.binary_id = binary_id;

		teModel.object.notify = false;

		try {
			await teModel.submit(false, API.RequestType.UPDATE);
		} catch (e) {
		}
	}

	handleClick(item) {
		this.handleNotify(item.pkey, item.binary_id).then();
	}

	render() {
		let items = this.state.notifications && this.state.notifications.length !== 0
			? this.state.notifications.map((item, key) => {
				return (<DropdownItem key={key} style={{color: "black"}} onClick={this.handleClick.bind(this, item)}>
					<Link style={{color: "black"}} to={this.renderLinks(item.name)}>
						{item.name}
					</Link>
					</DropdownItem>)
				})
			: this.state.pending_acquisitions > 0
				? ''
				: <DropdownItem>No Notifications</DropdownItem>;

		let badge;
		let pendingAcq;
		if (this.state.pending_acquisitions > 0 && this.state.notifications && this.state.notifications.length === 0 && !this.state.acquisitions_clicked) {
			badge = <Badge badgeContent={1} color={"error"}><i className={"fa fa-bell fa-lg"}/></Badge>;
			pendingAcq = <DropdownItem onClick={() => {this.setState({acquisitions_clicked: true})}}>
				<Link style={{color: "black"}} to={"/acquisitions/pendings"}>
					<span style={{color: "#67809f"}}>{this.state.pending_acquisitions} </span>
					Pending Acquisitions
				</Link>
			</DropdownItem>
		} else {
			badge = <Badge badgeContent={items.length} color="error"><i className={"fa fa-bell fa-lg"}/></Badge>
			pendingAcq = items !== '' ? '' : <DropdownItem>No Notifications</DropdownItem>
		}


		return (

			<Dropdown
				className="d-inline-block"
				onMouseOver={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
				isOpen={this.state.dropdownOpen}
				toggle={this.toggle}
				style={
					{
						paddingLeft: "20px",
						paddingRight: "10px",
						border: "1px solid transparent"
					}
				}
			>
				<DropdownToggle
					className="md-button header-btn"
					color={'none'}>
					{badge}
				</DropdownToggle>

				<DropdownMenu right>
					{items}
					{pendingAcq}
				</DropdownMenu>
			</Dropdown>

		)
	};
}

export default Framework.Components.withRootState(Notification)
